module.exports = __webpack_public_path__ + "img/circuit.245883d1.svg";